const bankNames = ["ADAM & CO (RBS PLC)",
    "ADAM & COMPANY",
    "AIB GB",
    "AL RAYAN BANK PLC",
    "APS FINANCIAL LTD",
    "BANK OF AMERICA, NA",
    "BANK OF SCOTLAND",
    "BARCLAYS BANK PLC",
    "BARCLAYS BANK PLC UK",
    "BARCLAYS BANK UK PLC",
    "BARCLAYS PRIVATE",
    "CATER ALLEN LTD",
    "CITIBANK EUROPE PLC",
    "CITIBANK UK LTD",
    "CLEARBANK",
    "CLYDESDALE",
    "CLYDESDALE BANK",
    "CONTIS FIN SERV LTD",
    "CO-OPERATIVE BANK",
    "COUTTS",
    "COVENTRY B/S",
    "CUMBERLAND BLG SOC",
    "HALIFAX",
    "halifax ",
    "HAMPDEN & CO. PLC",
    "HANDELSBANKEN",
    "HSBC BANK PLC",
    "HSBC BANK PLC (RFB)",
    "HSBC BANK PLC (RFB) uk",
    "HSBC UK BANK PLC",
    "IBP",
    "ICICI BANK UK PLC",
    "ISLE OF MAN BANK LTD",
    "LEEDS B S",
    "LLOYDS BANK PLC",
    "LLOYDS BANK PLC ",
    "LLOYDS INTERNATIONAL",
    "LLOYDS PRIVATE BANK",
    "MARSDEN BUILDING SOC",
    "METRO BANK",
    "MODULR",
    "MONZO BANK LIMITED",
    "NAT WEST BANK PLC",
    "Nationwide",
    "NATIONWIDE BLDG SCTY",
    "Nationwide Building Society",
    "natwest bank",
    "NATWEST BANK PLC",
    "NBL T/A DANSKE BANK",
    "PREPAY TECHNOLOGIES",
    "RBS INTERNTL LTD",
    "RBS ONE ACCOUNT",
    "ROYAL BANK OF SCOT",
    "ROYAL BANK OF SCOTLAND",
    "Santander",
    "SANTANDER CARDS UK",
    "SPECTRUM T/A CARDONE",
    "SPS LTD",
    "STARLING BANK LTD",
    "STATE BANK OF INDIA",
    "TESCO BANK",
    "THINK MONEY LTD",
    "TRIODOS BANK UK LTD",
    "TSB",
    "TSB BANK PLC",
    "ULSTER BANK LIMITED",
    "VIRGIN MONEY PLC",
    "VM CLYDESDALEBANKPLC",
    "WIRECARD",
    "Yorkshire ",
    "YORKSHIRE BANK",
    "YORKSHIRE BUILD SOCY"]

export default bankNames